import { render, staticRenderFns } from "./aboutAnswer.vue?vue&type=template&id=65171d1c&scoped=true"
import script from "./aboutAnswer.vue?vue&type=script&lang=js"
export * from "./aboutAnswer.vue?vue&type=script&lang=js"
import style0 from "./aboutAnswer.vue?vue&type=style&index=0&id=65171d1c&prod&lang=scss&scoped=true"
import style1 from "./aboutAnswer.vue?vue&type=style&index=1&id=65171d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65171d1c",
  null
  
)

export default component.exports